import * as React from 'react'
import classNames from 'classnames'

type ContainerProps = React.ComponentPropsWithoutRef<'div'>

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	({ children, className }, forwardedRef) => (
		<div
			className={classNames(`p-7 rounded-xl shadow-container w-full h-full bg-white ${className}`)}
			ref={forwardedRef}
		>
			{children}
		</div>
	),
)

Container.displayName = 'BoxContainer'
export default Container
